import React, { ReactNode } from 'react';
import { buildClassName } from 'utils/build-class-name';
import styles from './style.module.scss';
import { testIds } from 'constants/test-constants';
import { useThemeContext } from 'contexts';
import { ThemeNames } from 'types/themes';
import { sanitizeTestid } from 'utils/stringSanitization';

export interface Props {
  label: string | ReactNode;
  className?: string;
  children: ReactNode;
}

export default function Filter({ label, className, children }: Props) {
  const { themeName } = useThemeContext();
  const isExpTheme = themeName && themeName !== ThemeNames.ZOOCASA;

  return (
    <div className={buildClassName(styles.component, className, isExpTheme && styles['exp-theme'])} data-testid={sanitizeTestid(label.toString()) + testIds.filterGroup}>
      <h3>{label}</h3>
      {children}
    </div>
  );
}
